import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAttribution } from '../hooks/useAttribution';
import { useTrackVisit } from '../hooks/useCustomer';
import { isImpersonating } from '../lib/impersonation';

/**
 * หน้าแรก — เปิดจาก LIFF link
 *  - ?ch=...          → channel attribution
 *  - ?paid=1&order=N  → เพิ่งจ่ายเงินที่ Shopify, redirect ไป order detail
 */
export function Landing() {
  const attribution = useAttribution();
  const navigate = useNavigate();
  const track = useTrackVisit();
  const [params] = useSearchParams();

  const justPaid = params.get('paid') === '1';
  const paidOrderId = params.get('order');

  useEffect(() => {
    // Admin impersonation — skip tracking + LIFF context (no idToken)
    // Go straight to dashboard.
    if (isImpersonating()) {
      navigate('/dashboard', { replace: true });
      return;
    }

    track.mutate(
      { ...attribution, page: '/' },
      {
        onSuccess: (data) => {
          // เพิ่งจ่ายเงิน → ไปดูประวัติคำสั่งซื้อ (ถ้ามี order id ระบุไว้ → ไป detail)
          if (justPaid) {
            navigate(paidOrderId ? `/orders/${paidOrderId}` : '/orders', { replace: true });
            return;
          }

          if (data.needsRegistration) {
            const qs = new URLSearchParams();
            if (attribution.channel)  qs.set('ch', attribution.channel);
            if (attribution.campaign) qs.set('cmp', attribution.campaign);
            if (attribution.variant)  qs.set('v', attribution.variant);
            if (attribution.referrer) qs.set('ref', attribution.referrer);
            navigate(`/register?${qs.toString()}`, { replace: true });
          } else {
            navigate('/dashboard', { replace: true });
          }
        },
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center text-gray-500">
      {justPaid ? '✅ ชำระเงินสำเร็จ — กำลังกลับสู่ระบบ...' : 'กำลังตรวจสอบข้อมูล...'}
    </div>
  );
}
